<template>
  <svg
    width="260"
    height="244"
    viewBox="0 0 260 244"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect opacity="0.1" width="260" height="244" rx="10" fill="#0057EA" />
    <g filter="url(#filter0_d)">
      <rect x="22" y="27" width="216" height="55" rx="5" fill="white" />
    </g>
    <rect
      opacity="0.8"
      x="39"
      y="38"
      width="34"
      height="34"
      rx="5"
      fill="#0057EA"
    />
    <rect x="86" y="45" width="108" height="8" rx="4" fill="#E0E0E0" />
    <rect x="86" y="57" width="108" height="8" rx="4" fill="#E0E0E0" />
    <g filter="url(#filter1_d)">
      <rect x="22" y="94" width="216" height="55" rx="5" fill="white" />
    </g>
    <rect
      opacity="0.8"
      x="39"
      y="105"
      width="34"
      height="34"
      rx="5"
      fill="#0057EA"
    />
    <rect x="86" y="112" width="108" height="8" rx="4" fill="#E0E0E0" />
    <rect x="86" y="124" width="108" height="8" rx="4" fill="#E0E0E0" />
    <g filter="url(#filter2_d)">
      <rect x="22" y="161" width="216" height="55" rx="5" fill="white" />
    </g>
    <rect
      opacity="0.8"
      x="39"
      y="172"
      width="34"
      height="34"
      rx="5"
      fill="#0057EA"
    />
    <rect x="86" y="179" width="108" height="8" rx="4" fill="#E0E0E0" />
    <rect x="86" y="191" width="108" height="8" rx="4" fill="#E0E0E0" />
    <path
      d="M64 184H48C46.8954 184 46 184.895 46 186V196C46 197.105 46.8954 198 48 198H64C65.1046 198 66 197.105 66 196V186C66 184.895 65.1046 184 64 184Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M60 198V182C60 181.47 59.7893 180.961 59.4142 180.586C59.0391 180.211 58.5304 180 58 180H54C53.4696 180 52.9609 180.211 52.5858 180.586C52.2107 180.961 52 181.47 52 182V198"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M64 117H48C46.8954 117 46 117.895 46 119V129C46 130.105 46.8954 131 48 131H64C65.1046 131 66 130.105 66 129V119C66 117.895 65.1046 117 64 117Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M60 131V115C60 114.47 59.7893 113.961 59.4142 113.586C59.0391 113.211 58.5304 113 58 113H54C53.4696 113 52.9609 113.211 52.5858 113.586C52.2107 113.961 52 114.47 52 115V131"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M64 50H48C46.8954 50 46 50.8954 46 52V62C46 63.1046 46.8954 64 48 64H64C65.1046 64 66 63.1046 66 62V52C66 50.8954 65.1046 50 64 50Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M60 64V48C60 47.4696 59.7893 46.9609 59.4142 46.5858C59.0391 46.2107 58.5304 46 58 46H54C53.4696 46 52.9609 46.2107 52.5858 46.5858C52.2107 46.9609 52 47.4696 52 48V64"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_d"
        x="14"
        y="23"
        width="232"
        height="71"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.0862745 0 0 0 0 0.227451 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d"
        x="14"
        y="90"
        width="232"
        height="71"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.0862745 0 0 0 0 0.227451 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d"
        x="14"
        y="157"
        width="232"
        height="71"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.0862745 0 0 0 0 0.227451 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
